import React, {useCallback, useEffect, useState } from "react";

import {
  Box,
  Menu,
  MenuButton,
  MenuList, 
  useColorModeValue,
  Flex,
  Icon
} from "@chakra-ui/react";
import TdsAddNew from "components/allForm/TdsExpense/tdsAddNew";
import ColumnTable from "./embrillTable/ColumnTable";
import { columnsDataColumns,pendingDataColumns,rejectedDataColumns } from "./embrillTable/variables/tdsColData";
import { useDispatch, useSelector } from "react-redux";
import { fetchAsyncGetTDSExpense } from "redux/tdsSlice";
import { poNumberFormate } from "jsFunctions/helperFunctions";
import { BsFillFileEarmarkPdfFill } from "react-icons/bs";
import { AiFillDelete, AiFillEye } from "react-icons/ai";
import { fetchAsyncDeleteTdsExpense } from "redux/tdsSlice";
import PdfListModel from "components/models/PdfListModel";
import { fetchAsyncDeleteTdsPdf } from "redux/tdsSlice";
import dateTimeFormat from "jsFunctions/dateTimeFormat";
import { currencyFormate } from "jsFunctions/helperFunctions";
import TdsInfoModel from "components/models/TdsInfoModel";
import ExpenseReports from "./expenseGraph";
import { TbReceiptTax } from "react-icons/tb";
import { CiExport, CiViewTable } from "react-icons/ci";
import { PiGraph } from "react-icons/pi";
import { MdModeEdit } from "react-icons/md";
import ExportDataModel from "components/exportData/ExportDataModel";
import { fetchAsyncDeleteExpense } from "redux/userSlice";
import { formatAmountInINR } from "jsFunctions/formatAmountInINR";
import SpentAmountPopover from "components/models/spentAmountPopover";
import { FaEllipsisV,FaPlus } from "react-icons/fa";
import { TbFileExport } from "react-icons/tb";
import SpinnerLoader from "components/Spinner/SpinnerLoader";
import { useToasts } from "react-toast-notifications";
import prJson from "components/jsonData/purchase.json"
import ConfirmationDialog from "components/sweetAlert.js/ConfirmationDialog";
import useSearch from "hooks/useSearch";

const EmbrillTds = () => {
  const [openTdsModal, setOpneTdsModal] = useState(false);
  const [tdsData, setTdsData] = useState("");
  const [openEditModal, setOpenEditModal] = useState(false);
  const [tdsEditData, setTdsEditData] = useState(null);
  const [tdsListData, setTdsListData] = useState([]);
  const [tdsPdfList, setTDSPdfList] = useState(null);
  const [showPdfList, setShowPdfList] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [activeDataList,setActiveDataList] = useState('approved')
  const [invoiceData,setInvoiceData] = useState([])
  const [activeGraph,setActiveGraph] = useState(false)
  const [openTdsInfoModel, setOpenTdsInfoModel] = useState(false);
  const dispatch = useDispatch();
  const tdsList = useSelector((state) => state.tdsData.tdsExpense);
  const tdsPayData = useSelector((state) => state.tdsData)
  const currUser = useSelector((state) => state.auth.currUser);
  const {searchText} = useSelector((state) => state.searchValue); // Access the dateRange slice
  const [role,setRole] = useState('')  
  const { startDate, endDate } = useSelector((state) => state.dateRange); // Access the dateRange slice
  const { addToast } = useToasts();
  const { performSearch } = useSearch();
  const [loading, setLoading] = useState(false);

  useEffect(()=>{
    if(currUser && currUser?.auth){

      const auth = currUser?.auth;
      const roleObj = auth && auth?.length > 0 && auth.find((item)=> item?.module === 'Tax Deducted at Source (TDS)');
      if(roleObj){

        setRole(roleObj?.access)
      }
    }
   
  },[currUser])

  const deleteTdsData = (data) => {
    const pono = poNumberFormate(data.poNo)
    setLoading(true)
    dispatch(fetchAsyncDeleteTdsExpense(data._id)).then(() => {
      handlerRefreshData();
      const msg = prJson.success.deletedPr.replace("{prno}",pono)
      addToast(msg, { appearance: "success" });       setLoading(false)
    }).catch((err)=>{
      setLoading(false)
      addToast(prJson.failed.deletedPr, { appearance: "error" });
    });
  };
  const hardDeleteTdsData = (data) => {
    const objData = {
      id:data._id,
      type:'tds'
    }
    const pono = poNumberFormate(data.poNo)
    setLoading(true)
    dispatch(fetchAsyncDeleteExpense(objData)).then((res) => {
      handlerRefreshData();
      const msg = prJson.success.deletedPo.replace("{pono}",pono)
      addToast(msg, { appearance: "success" });       setLoading(false)

    }).catch((err)=>{
      setLoading(false)
      addToast(prJson.failed.deletedPr, { appearance: "error" });

    });
  };
  
   const handlerRefreshData = useCallback(
      () => {
        performSearch(searchText, startDate, endDate);
      },
      [searchText,startDate,endDate,performSearch]
    );



  const handleCloseTdsModal = (active) => {
    setOpneTdsModal(false);
    setOpenEditModal(false);
    setTdsEditData(null);
    handlerRefreshData();
    if(active){
      setActiveDataList(active)
    }
  };
  useEffect(() => {
    setLoading(true); 
    dispatch(fetchAsyncGetTDSExpense())
      .then(() => {
        setLoading(false); 
      })
      .catch((error) => {
        setLoading(false); 
      });
    
  }, []);
  const handleOpenTdsModal = () => {
    setOpneTdsModal(true);
  };
  
  const getAllTdsData = (listData)=>{
    if (listData && listData.length > 0) {
      const tableData = listData.map((data, index) => {
        let foundInvoiceWithLength = false;

        const array = data?.pyInfo?.list || [];
        const invArray = data?.pyInfo?.inv || [];

        const spentAmounts = array.map(item => parseFloat(item?.amt || 0)); 
        const totalSpent = array.reduce((acc, item) => acc + (parseFloat(item?.amt) || 0), 0);
        const refundAmount = data?.rfdInfo?.list || []
        const totalRefund = refundAmount.reduce((acc, item) => acc + (parseFloat(item?.amt) || 0), 0);

          if (invArray && invArray.length > 0) {
            foundInvoiceWithLength = true;
          }
        
        return {
          _id:data._id,
          no: index + 1,
          poNo: (
            <span 
              style={{ cursor: "pointer",color:'blue'}}
            >
              {data.poNo && poNumberFormate(data.poNo)}
            </span>
          ),
          orderdate: dateTimeFormat(data.oDt),
          resourcename: <span style={{ cursor: "pointer" }}>{data?.resId ? data?.resId?.name : ""}</span>,
          sortTlAmt:Number(data?.tlBlAmt) || 0,
          totalAmount: data?.tlBlAmt ? currencyFormate(data?.tlBlAmt): <div dangerouslySetInnerHTML={{ __html: `<span style="font-family: sans-serif">₹</span> ${Number(0).toFixed(2)}` }} />,
          sortReqAmt:Number(data.pyInfo?.apAmt) || 0,
          approvalAmount: (
            <span
              style={{ cursor: "pointer" }}
              className={data.pyInfo?.sts !== 1 ? 'red' :'green'}

            >
              {data.pyInfo?.apAmt ? currencyFormate(data.pyInfo?.apAmt): <div dangerouslySetInnerHTML={{ __html: `<span style="font-family: sans-serif">₹</span> ${Number(0).toFixed(2)}` }} />}
            </span>
          ),
          sortApdAmt: data.pyInfo?.tlAmt || 0,
          approvedAmount: 
          (
            <span 
            style={{ cursor: "pointer" }}
          >
            {data.pyInfo?.tlAmt ? currencyFormate(data.pyInfo?.tlAmt) : <div dangerouslySetInnerHTML={{ __html: `<span style="font-family: sans-serif">₹</span> ${Number(0).toFixed(2)}` }} />}
            </span>
          ), 
          sortSpentAmt: totalSpent ? parseFloat(totalSpent) - parseFloat(totalRefund || 0) : 0,

          spentAmount: 
          <Box display="flex" >
          <span
              style={{ cursor: "pointer", width:'90px' }}
              className={ (parseFloat(totalSpent) - parseFloat(totalRefund)) !== 0 ? 'green' :''}

            >
              {formatAmountInINR(totalSpent ? parseFloat(totalSpent) - parseFloat(totalRefund || 0) : 0)}
            </span>
          
          <SpentAmountPopover spentAmounts={spentAmounts} refundAmount={refundAmount}/>
           </Box>
          ,
          invoice:
          foundInvoiceWithLength ? (
              <BsFillFileEarmarkPdfFill
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  e.preventDefault();
                  setShowPdfList(true);
                  setTDSPdfList(data);
                }}
              />
            ) : (
              <BsFillFileEarmarkPdfFill
                style={{ cursor: "not-allowed" }}
                color="gray"
              />
            ),
            status:'Rejected',

          action: (
            <div className="d-flex">
              <MdModeEdit
                className="me-2"
                color="blue"
                size={16}
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  handleRowClick(e,data._id)
                }}
              />
              <AiFillEye
                className="me-2"
                color="#000D55"
                size={16}
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  e.preventDefault();
                  setSelectedItem(data);
                  setOpenTdsInfoModel(true);
                }}
              />
              {role === "Admin" && (
                <>
                <AiFillDelete
                  style={{ cursor: "pointer" }}
                  size={16}

                  onClick={(e) => {
                    e.preventDefault();
                    const title = prJson.confirm.deleteExpense.replace("{poNumber}", data.poNo ? poNumberFormate(data.poNo) : "");
                    ConfirmationDialog({
                      title: title,
                      text: prJson.text.undone,
                      icon: 'warning',
                      confirmButtonText: 'Delete',
                      cancelButtonText: 'Cancel',
                      onConfirm: () => {
                        deleteTdsData(data);
                      },
                    });
                  }}
                />
                 <AiFillDelete
                  style={{ cursor: "pointer",color:'red',marginLeft:'3px' }}
                  size={16}

                  onClick={(e) => {
                    e.preventDefault();
                    const title = prJson.confirm.deleteExpense.replace("{poNumber}", data.poNo ? poNumberFormate(data.poNo) : "");
                    ConfirmationDialog({
                      title: title,
                      text: prJson.text.undone,
                      icon: 'warning',
                      confirmButtonText: 'Delete',
                      cancelButtonText: 'Cancel',
                      onConfirm: () => {
                        hardDeleteTdsData(data);
                      },
                    });
                  }}
                />
                </>
              )}
            </div>
          ),
        };
      });
      setTdsListData(tableData);
      if (tdsPdfList) {
        const dataGet = tdsList.filter((item) => item._id === tdsPdfList._id);
        setTDSPdfList(dataGet[0]);
      }
      if (tdsEditData) {
        const dataGet = tdsList.filter((item) => item._id === tdsEditData._id);
        setTdsEditData(dataGet[0]);
      }
    } else {
      setTdsListData([]);
    }
  }

  
  const handleInternalListData = ()=>{
    if (!tdsList || tdsList.length === 0) {
      setTdsListData([]);
      return;
    }
  
    const listData = tdsList.filter(item => {
      if (activeDataList === 'approved') {
        return item.pyInfo.sts === 1;
      }
      if (activeDataList === 'pending') {
        return item.pyInfo.sts === 0
      }
      return item.pyInfo.sts === 2
    });
  
    getAllTdsData(listData);
  }

  useEffect(() => {
    handleInternalListData()
  }, [tdsList , activeDataList]);

  const handleGraph = ()=>{
    setActiveGraph(true)
  }
  const handleTable = ()=>{
    setActiveGraph(false)
  }

  const handleRowClick = (e,_id)=>{
    e.stopPropagation();
    const data = tdsList.filter((item)=> item?._id === _id)
    setOpenEditModal(true);
    setTdsEditData(data[0]);
    handleOpenTdsModal();
  }

  const closeTdsInfoModel = () => {
    setOpenTdsInfoModel(false);
    setSelectedItem({});
  };

  useEffect(()=>{
    if (tdsPdfList) {
      const dataGet = tdsList.filter(
        (item) => item._id === tdsPdfList._id
      );
      const data = dataGet[0];
      const invs = data?.pyInfo?.inv || [];

      setInvoiceData(invs)
      setTDSPdfList(dataGet[0]);
    }
  },[tdsPdfList])

  const deleteFileFromList = (sendData) => {
    dispatch(fetchAsyncDeleteTdsPdf(sendData)).then((response) => {
      handlerRefreshData();
    });
  };
  const shadow = useColorModeValue(
    "14px 17px 40px 4px rgba(112, 144, 176, 0.18)",
    "14px 17px 40px 4px rgba(112, 144, 176, 0.06)"
  );
  let menuBg = useColorModeValue("white", "navy.800");
  const borderColor = useColorModeValue("#E6ECFA", "rgba(135, 140, 189, 0.3)");

  const [isOpen, setIsOpen] = useState(false);
  const [activeBtn,setActiveBtn] = useState("")

  const toggleMenu = (btn) => {
    setIsOpen(!isOpen);
    setActiveBtn(btn)
  };
  const handleClose = () => {   
    setActiveBtn("");   
    setIsOpen(false)
  };


   // If loading, return a spinner
   if (loading) {
    return (
      <SpinnerLoader/>

    );
  }
  return (
    <>
    <Box display="flex" className="mx-0" justifyContent="space-between">
        <Box display="flex" justifyContent="space-between" className="tab-btn mx-2">
        {!activeGraph &&
          <Box className="tab-btn-div">
            <div
              className={`div-btn ${
                activeDataList === "approved" ? "active-tab-btn" : ""
              }`}
              onClick={() => setActiveDataList("approved")}
            >
              Approved
            </div>
            <div
              className={`div-btn ${
                activeDataList === "pending" ? "active-tab-btn" : ""
              }`}
              onClick={() => setActiveDataList("pending")}
            >
              Pending
            </div>
            <div
              className={`div-btn ${
                activeDataList === "rejected" ? "active-tab-btn" : ""
              }`}
              onClick={() => setActiveDataList("rejected")}
            >
              Rejected
            </div>
          </Box>
        }
        </Box>

        <div 
        className="graph_button internal-graph-btn mx-2"        
       >
        <button title="Data View" className={`graph_icon_button ${!activeGraph ? 'active_graph' : ''}`}  onClick={()=>handleTable()}><CiViewTable  /></button>
        {role !== 'Accountant' ?
        <button  title="Analytics View" className={`graph_icon_button ${activeGraph ? 'active_graph' : ''}`} onClick={()=>handleGraph()}><PiGraph/></button>
        :
        <button title="Analytics View"  className={`graph_icon_button ${activeGraph ? 'active_graph' : ''}`} style={{opacity:'0.3',cursor:'not-allowed'}}><PiGraph/></button>
        }
        
       </div>
       {!activeGraph && 
        <Box display="flex" mt={2} className="add-new-btn">
          <Box
            display="flex"
            alignItems="center"
            className="new-btn"
            onClick={handleOpenTdsModal}
          >
            <FaPlus size={12} className="new-plus-icon"/> New
          </Box>
          <Box>
          <Menu>
          <MenuButton p="0px">
          <Box  className='menu-ellipsis-btn'><FaEllipsisV /></Box>

          </MenuButton>
          <MenuList
             boxShadow={shadow}
             p="0px"
             mt="10px"
             borderRadius="10px"
             bg={menuBg}
             border="none"
          >
            <Flex w="100%" mb="0px" flexDirection="column">
            <Box
                ps="20px"
                pt="10px"
                pb="8px"
                className="menu-text"
                borderBottom="1px solid gray"
                borderColor={borderColor}
                onClick={()=>toggleMenu('xlsx')}
                display="flex"
               
              >
                <CiExport size={20} className="mx-1"/> <span>Export XLSX</span>
                
              </Box>
             
            </Flex>
            <Flex w="100%" mb="0px" flexDirection="column">
            <Box
                ps="20px"
                pb="8px"
                pt="5px"
                borderBottom="1px solid gray"
                borderColor={borderColor}
                display="flex"
                className="menu-text"
                onClick={()=>toggleMenu('invoice')}


              >
                <TbFileExport size={20} className="mx-1"/> 
                <span>Export Invoice</span>
                
              </Box>
            </Flex>
           <Box marginRight={40}>
           {isOpen && (
            <ExportDataModel
              filename={"TDS_"}
              type="tds"
              role={role}
              isOpen={isOpen}
              handleClose={handleClose}
              activeBtn={activeBtn}
            />
          )}
           </Box>
          </MenuList>
        </Menu>
          </Box>
         
        
        </Box>
        }
      </Box>
      
      <Box pt={{ base: "60px", md: "10px", xl: "10px" }}>


      {activeGraph ?
      <Box className={`graph-card ${activeGraph ? 'graph_active' : ''}`}>
          
      <ExpenseReports
        type='tds'
        name = 'TDS Total Expense'
        heading = "TDS"
        icon = {<Icon w="22px" h="22px" as={TbReceiptTax} />}
        role={role}
      /> 
      </Box>
      :
        <ColumnTable
        columnsData = {activeDataList === 'rejected' ?rejectedDataColumns :activeDataList === 'pending'? pendingDataColumns:columnsDataColumns} 
        tableData={tdsListData}
          type={"Tax Deducted at Source (TDS)"}
          expenseType = 'tds'

          getAllData={(data) => {
            setTdsData(data);
            handleOpenTdsModal();
          }}
          openInfoModal = {handleRowClick}
          activeDataList = {activeDataList}
          role={role}
          paymentData = {tdsPayData}
          chnageDataList={(value)=>setActiveDataList(value)}

        />
      }
      </Box>
      {openTdsModal && (
        <TdsAddNew
          tdsOpen={openTdsModal}
          tdsClose={handleCloseTdsModal}
          tdsExpenseData={tdsData}
          isEditForm={openEditModal}
          editItem={tdsEditData}
          refreshEditData={handlerRefreshData}
          activeList = {activeDataList}
          role={role}

        />
      )}
      <PdfListModel
          pdfData={tdsPdfList ? invoiceData : []}
          currentId={tdsPdfList ? tdsPdfList._id : ""}
        openModal={showPdfList}
        closeModal={() => {
          setShowPdfList(false);
          setTDSPdfList(null);
        }}
        deleteFileFromList={deleteFileFromList}
        role={role}
      />
      {openTdsInfoModel && (
        <TdsInfoModel
          openInfoModal={openTdsInfoModel}
          closeInfoModal={closeTdsInfoModel}
          selectedItem={selectedItem} 
          role={role}       
        />
      )}
    </>
  );
};

export default EmbrillTds;
